import React, {useState, useEffect, useCallback, useContext} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import FullBodyContentView from '../../views/fullBodyContentView';
import ZeroCompleteFinished from './zero-completeFinished';

function ZeroComplete({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onComponent, selected} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onExit();
    onComponent(<ZeroCompleteFinished />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;
    onLeft();
  }, [leftPress]);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <FullBodyContentView
      title="Zero Complete"
      fullCaption="Offset..............................0.0f...........
      Standard Deviation.........0.0f...........
      ............................................................
      ............................................................
      ............................................................
      ............................................................
      "
    />
  );
}

export default ZeroComplete;
